module.exports = __webpack_public_path__ + "static/team-work-480387e4c192cec4f66ea744c33000dc.png";